import React from 'react'
import { Link } from 'react-router-dom'
import { Title } from '../components'

const NotFound = () => (
  <main>
    <Title message="Stránka nebyla nalezena" />
    <p>Bohužel Vámi hledaná stránka nebyla nalezena, pokračujte prosím <Link to="/">zde</Link></p>
  </main>
)

export default NotFound



// WEBPACK FOOTER //
// ./src/browser/pages/NotFound.js